import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import MapSummary from './MapSummary'

const MapLink = styled(Link)`
  font-family: 'Montserrat', sans-serif;
  font-weight: 400;
  color: white;
  font-size: 14px;
  text-decoration: none;
`
const CardContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(230px, 230px));
  grid-gap: 2em;
  background: #0063c0;
  padding: 4em;
`

class MapList extends Component {
  render() {
    const { topic, maps, authorUid } = this.props;
    let authorFilteredMaps = authorUid === undefined ? 
      maps : maps.filter(learnmap => learnmap.authorId === authorUid)
    let topicFilteredMaps = topic.topic === "" ? 
      maps : maps.filter(learnmap => learnmap.topic === topic.topic)
    let filteredMaps = authorUid ? authorFilteredMaps : topicFilteredMaps
    return (
      <CardContainer>
        { maps && filteredMaps.map(map => {
          return (
            <MapLink to={'/map/' + map.id} key={map.id}>
              <MapSummary map={map} />
            </MapLink>
          )
        })}
     </CardContainer>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    topic: state.topic
  }
}

export default connect(mapStateToProps)(MapList)



// WEBPACK FOOTER //
// ./src/components/maps/MapList.js